const positionUrls = {
    fetchPositions: {
        url: '/position'
    },
    fetchPosition: {
        url: '/position/:id'
    },

};
export default positionUrls;